// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".emptyOrderButton[data-v-c9d7096c]{align-items:center;background:#fff;border:1px solid #cccfd7;border-radius:11px;color:#010d35;cursor:pointer;display:flex;flex-direction:column;font-size:14px;font-weight:500;height:74px;justify-content:center;line-height:18px;padding:12px;width:100%;@media(min-height:700px){height:90px}}.emptyOrderButton__icon[data-v-c9d7096c]{margin-bottom:6px}.novikov .emptyOrderButton[data-v-c9d7096c]{color:#ee1623}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
